document.addEventListener("DOMContentLoaded", function() {
  const variantSelector = document.getElementById("variant-selector");
  const variantPrice = document.getElementById("variant-price");
  const selectedVariantId = document.getElementById("selected-variant-id");

  if (variantSelector) {
    variantSelector.addEventListener("change", function() {
      const selectedOption = variantSelector.options[variantSelector.selectedIndex];
      const newPrice = selectedOption.getAttribute("data-price");
      const newVariantId = selectedOption.value;

      variantPrice.textContent = newPrice;
      selectedVariantId.value = newVariantId;
    });
  }
});
